import type { JWT } from 'aws-amplify/auth';

// Money is just a string in the format "d(d)*.dd" or "-d(d)*.dd".
// It's a marker type; TypeScript can't enforce the shape.
export type Money = string;

export enum UserRole {
  ADMINISTRATOR = 'administrator',
  MANAGER = 'manager',
  USER = 'user',
}

export type IvJwt = JWT & {
  payload: {
    given_name: string;
    family_name: string;
    email: string;
    phone_number?: string; // format is like +19999999999
    'custom:appRole': UserRole;
    'custom:tenant': string;
  };
};
